// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MqVH","tabsBox":"styles_tabsBox__14jAC","createButton":"styles_createButton__3Rg9G"};